import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import api from '../../utils/api';

// Async thunk for fetching client data
export const fetchClientData = createAsyncThunk(
  'client/fetchClientData',
  async (clientId, { rejectWithValue }) => {
    try {
      // console.log('clientId:', clientId);
      if (clientId == null) {
        throw new Error('Client ID is required');
      }

      const response = await api.get(`advisor/${clientId}`);
      // console.log('clientId response:', response);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Unknown error');
    }
  }
);

export const sendOtp = createAsyncThunk(
  'client/sendOtp',
  async (data, { rejectWithValue }) => {
    try {
      // console.log('📨 Sending OTP to clientId:', clientId);
      if (!data?.clientId && !data?.mobile) {
        throw new Error('Client ID and Mobile no. is required');
      }

      // const response = await api.post(`advisor/send-otp`, {data});
      const response = await api.post(`advisor/send-otp-auth`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to send OTP');
    }
  }
);
export const verifyOtp = createAsyncThunk(
  'advisor/verifyOtp',
  async ({ clientId, otp }, { rejectWithValue }) => {
    try {
      if (!clientId || !otp) {
        throw new Error("Client ID and OTP are required");
      }

      const response = await api.post(`advisor/verify-otp/${clientId}`, { otp });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Failed to verify OTP"
      );
    }
  }
);
const clientSlice = createSlice({
  name: 'client',
  initialState: {
    clientData: {},
    loading: false,
    error: null,
    otpStatus: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 🔄 Fetch Client
      .addCase(fetchClientData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientData.fulfilled, (state, action) => {
        state.loading = false;
        state.clientData = action.payload;
      })
      .addCase(fetchClientData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 📤 Send OTP
      .addCase(sendOtp.pending, (state) => {
        state.otpStatus = 'sending';
        state.error = null;
      })
      .addCase(sendOtp.fulfilled, (state) => {
        state.otpStatus = 'sent';
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.otpStatus = 'failed';
        state.error = action.payload;
      })

      // ✅ Verify OTP
      .addCase(verifyOtp.pending, (state) => {
        state.otpStatus = 'verifying';
        state.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state) => {
        state.otpStatus = 'verified';
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.otpStatus = 'verify_failed';
        state.error = action.payload;
      });
  },
});


export default clientSlice.reducer;
